"use client";

import * as S from "./styles.ts";
import { IDomainsSlice } from "@/redux/slices/domains/types.ts";
import Header from "@template/blocks/domain/DomainNameCustomSearchResults/Header";
import Results, {
  ResultsProps,
} from "@template/blocks/domain/DomainNameCustomSearchResults/Results";

export type DomainNameCustomSearchResultsProps = {
  header?: {
    title: string;
    subTitle: string;
  };
  results?: IDomainsSlice["search"]["results"];
  loading?: boolean;
  available?: Omit<ResultsProps, "loading" | "results">;
  unavailable?: Omit<ResultsProps, "loading" | "results">;
  hidePrimary?: boolean;
};

const DomainNameCustomSearchResults = ({
                                         header,
                                         results,
                                         loading,
                                         available,
                                         unavailable,
                                         hidePrimary,
                                       }: DomainNameCustomSearchResultsProps) => {
  const totalLength = results?.available?.length + results?.unavailable?.length;
  if (!totalLength && !loading) return null;
  return (
    <S.Wrapper>
      <S.Container>
        <Header
          title={header?.title}
          subTitle={header?.subTitle}
          hidePrimary={hidePrimary}
        />
        <Results
          results={results?.available}
          loading={loading}
          {...available}
        />
        <Results
          results={results?.unavailable}
          loading={loading}
          {...unavailable}
          isUnavailable
        />
      </S.Container>
    </S.Wrapper>
  );
};

export default DomainNameCustomSearchResults;
